import React, { useContext } from 'react';
import styled from 'styled-components';

import Loading from 'components/Loading/Loading';
import Alert from 'kingpin/Alert';

import { BonusOverviewContext } from '../../providers/BonusOverviewProvider';
import AddAdditionalPaymentForm from './AddAdditionalPaymentForm';
import { AdditionalPaymentsModeContext } from './AdditionalPaymentsModeProvider';
import ManageAdditionalPayments from './ManageAdditionalPayments';

const PanelDiv = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
`;

// The slideout body while in recognition payments mode. Its state (the GET,
// the form) lives in AdditionalPaymentsModeProvider, shared with the header.
const AdditionalPaymentsPanel = () => {
  const { bonusOverview } = useContext(BonusOverviewContext);
  const { view, response, isLoading, hasFailed } = useContext(
    AdditionalPaymentsModeContext,
  );

  const content = (() => {
    if (!bonusOverview || isLoading) {
      return <Loading />;
    }
    if (hasFailed || !response) {
      return (
        <Alert type={'Danger'} body={'Failed to load additional payments'} />
      );
    }
    if (view === 'add') {
      return (
        <AddAdditionalPaymentForm
          bonusOverview={bonusOverview}
          response={response}
        />
      );
    }
    return (
      <ManageAdditionalPayments
        bonusOverview={bonusOverview}
        response={response}
      />
    );
  })();

  return <PanelDiv>{content}</PanelDiv>;
};

export default AdditionalPaymentsPanel;
